import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function GuaranteeSection() {
  return <section className="w-full border-t border-white/10 bg-ink-900 py-16 sm:py-20" aria-labelledby="garantia-title" data-id="element-36" data-mp="9ucs18y43p3p">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-37" data-mp="euh84xv3yhte">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-60px'
      }} transition={{
        duration: 0.5
      }} className="rounded-2xl border border-amber-brand/30 bg-ink-950 p-7 text-center sm:p-10" data-id="element-38" data-mp="er383w9x2kp4">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-amber-brand/15 text-amber-brand" data-id="element-39" data-mp="xjxj6f4f5so2">
            <ShieldCheckIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="12jthpyuckrw8" />
          </span>
          <h2 id="garantia-title" className="mt-5 font-display text-3xl font-bold uppercase text-white sm:text-4xl" data-id="element-41" data-mp="17hlizjgvtqd3">
            Garantía de blindaje
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-white/70" data-id="element-42" data-mp="20saw8ext1fqp">
            Tenés <strong className="font-semibold text-white" data-id="element-43" data-mp="1vt7ounucqxfk">7 días</strong>{' '}
            para revisar el material. Si sentís que no aprendiste nada nuevo o
            que no te va a ayudar a ahorrar plata, te devuelvo el 100% de tu
            inversión.{' '}
            <span className="text-amber-brand" data-id="element-44" data-mp="2okizgs1uzsc6">Sin preguntas incómodas.</span>
          </p>
        </motion.div>

        <div id="comprar" className="mt-12 scroll-mt-24" data-id="element-45" data-mp="2jloblbp1bdl7">
          <CtaButton location="garantia" subLabel="Oferta de lanzamiento por tiempo limitado" data-id="element-46" data-mp="2erai5etxngj6" />
        </div>
      </div>
    </section>;
}